import { render } from "./DadosExtrasIpiranga.vue?vue&type=template&id=1e74bc16&scoped=true&ts=true"
import script from "./DadosExtrasIpiranga.vue?vue&type=script&lang=ts"
export * from "./DadosExtrasIpiranga.vue?vue&type=script&lang=ts"

import "./DadosExtrasIpiranga.vue?vue&type=style&index=0&id=1e74bc16&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e74bc16"]])

export default __exports__